// import { Link } from "react-router-dom";
// import "./Settings.css";

// const Settings = () => {
//   return (
//     <>
//       <div id="settings-main-wrapper">
//         <div className="powered-by-app-mingle-media-inner">
//           <h6>Path 4 U Admin Software</h6>
//           <p>
//             Powered by
//             <Link
//               to={"https://appminglemedia.com/"}
//               style={{ textDecoration: "none" }}
//             >
//               &nbsp;AppMingle Media
//             </Link>
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Settings;

// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const Settings = () => {
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const [subAdmins, setSubAdmins] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [formData, setFormData] = useState({
//     username: "",
//     mobile: "",
//     password: "",
//   });

//   /* ---------------- FETCH SUB ADMINS ---------------- */
//   const fetchSubAdmins = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/admin/subadmin`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((res) => {
//         setSubAdmins(res.data);
//         setLoading(false);
//       })
//       .catch(() => {
//         alert("Failed to load sub admins");
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     fetchSubAdmins();
//   }, []);

//   /* ---------------- FORM HANDLERS ---------------- */
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const openCreate = () => {
//     setEditId(null);
//     setFormData({ username: "", mobile: "", password: "" });
//     setShowForm(true);
//   };

//   const openEdit = (admin) => {
//     setEditId(admin._id);
//     setFormData({
//       username: admin.username,
//       mobile: admin.mobile,
//       password: "",
//     });
//     setShowForm(true);
//   };

//   /* ---------------- CREATE / UPDATE ---------------- */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.username || !formData.mobile) {
//       alert("All fields are required");
//       return;
//     }

//     const url = editId
//       ? `${API_BASE_URL}/admin/subadmin/${editId}`
//       : `${API_BASE_URL}/admin/subadmin`;

//     const method = editId ? axios.put : axios.post;

//     method(url, formData, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//       .then(() => {
//         alert(editId ? "Sub Admin Updated" : "Sub Admin Created");
//         setShowForm(false);
//         fetchSubAdmins();
//       })
//       .catch(() => alert("Operation failed"));
//   };

//   /* ---------------- ACTIVATE / DEACTIVATE ---------------- */
//   const toggleStatus = (id) => {
//     axios
//       .patch(
//         `${API_BASE_URL}/admin/subadmin/${id}/status`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       )
//       .then(fetchSubAdmins)
//       .catch(() => alert("Failed to update status"));
//   };

//   /* ---------------- UI ---------------- */
//   return (
//     <div style={{ padding: 20, background: "#f4f6f9", minHeight: "100vh" }}>
//       <h2>Sub Admin Management</h2>

//       {/* FORM (TOP, TOGGLE) */}
//       <div
//         style={{
//           display: showForm ? "block" : "none",
//           background: "#fff",
//           padding: 20,
//           borderRadius: 8,
//           marginBottom: 20,
//           boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
//         }}
//       >
//         <h3>{editId ? "Update Sub Admin" : "Create Sub Admin"}</h3>

//         <form onSubmit={handleSubmit}>
//           <input
//             name="username"
//             placeholder="Email"
//             value={formData.username}
//             onChange={handleChange}
//             style={inputStyle}
//           />

//           <input
//             name="mobile"
//             placeholder="Mobile"
//             value={formData.mobile}
//             onChange={handleChange}
//             style={inputStyle}
//           />

//           <input
//             name="password"
//             type="password"
//             placeholder="Password"
//             value={formData.password}
//             onChange={handleChange}
//             style={inputStyle}
//           />

//           <div style={{ display: "flex", gap: 10 }}>
//             <button type="submit" style={primaryBtn}>
//               Save
//             </button>
//             <button
//               type="button"
//               onClick={() => setShowForm(false)}
//               style={secondaryBtn}
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>

//       {/* CREATE BUTTON */}
//       <button onClick={openCreate} style={{ ...primaryBtn, marginBottom: 10 }}>
//         + Create Sub Admin
//       </button>

//       {/* TABLE */}
//       <table style={tableStyle}>
//         <thead>
//           <tr>
//             <th>Email</th>
//             <th>Mobile</th>
//             <th>Status</th>
//             <th style={{ textAlign: "right" }}>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {loading ? (
//             <tr>
//               <td colSpan="4" style={{ textAlign: "center" }}>
//                 Loading...
//               </td>
//             </tr>
//           ) : (
//             subAdmins.map((admin) => (
//               <tr key={admin._id} style={column} >
//                 <td>{admin.username}</td>
//                 <td>{admin.mobile}</td>
//                 <td>{admin.isActive ? "Active" : "Inactive"}</td>
//                 <td style={{ textAlign: "right" }}>
//                   <button
//                     onClick={() => openEdit(admin)}
//                     style={editBtn}
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => toggleStatus(admin._id)}
//                     style={admin.isActive ? dangerBtn : successBtn}
//                   >
//                     {admin.isActive ? "Deactivate" : "Activate"}
//                   </button>
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// /* ---------------- STYLES ---------------- */
// const inputStyle = {
//   width: "100%",
//   padding: 10,
//   marginBottom: 10,
//   borderRadius: 6,
//   border: "1px solid #ccc",
// };

// const primaryBtn = {
//   background: "#2563eb",
//   color: "#fff",
//   padding: "10px 14px",
//   border: "none",
//   borderRadius: 6,
//   cursor: "pointer",
// };

// const secondaryBtn = {
//   background: "#e5e7eb",
//   padding: "10px 14px",
//   border: "none",
//   borderRadius: 6,
//   cursor: "pointer",
// };

// const editBtn = {
//   background: "#facc15",
//   padding: "6px 10px",
//   border: "none",
//   borderRadius: 5,
//   marginRight: 6,
// };

// const dangerBtn = {
//   background: "#dc2626",
//   color: "#fff",
//   padding: "6px 10px",
//   border: "none",
//   borderRadius: 5,
// };

// const successBtn = {
//   background: "#16a34a",
//   color: "#fff",
//   padding: "6px 10px",
//   border: "none",
//   borderRadius: 5,
// };

// const tableStyle = {
//   width: "100%",
//   background: "#fff",
//   padding: "10px 10px",
//   borderCollapse: "collapse",
// };

// const column = {
//   padding:"10px 10px"
// }

// export default Settings;











// import React, { useEffect, useState } from "react";
// import axios from "axios";

// /* 🔹 SERVICES (MUST MATCH BACKEND ENUM) */
// const SERVICES = [
//   { label: "Exam Notes", value: "exam_notes" },
//   { label: "Choose Career", value: "choose_career" },
//   { label: "Home Tutor", value: "home_tutor" },
//   { label: "Homework Assistance", value: "homework_assistance" },
//   { label: "Subjective Exam", value: "subjective_exam" },
//   { label: "Assignment", value: "assignment" },
//   { label: "Student Scholarship", value: "student_scholarship" }
// ];

// const Settings = () => {
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const [subAdmins, setSubAdmins] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [formData, setFormData] = useState({
//     username: "",
//     mobile: "",
//     password: "",
//     services: []
//   });

//   /* ---------------- FETCH SUB ADMINS ---------------- */
//   const fetchSubAdmins = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/admin/subadmin`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((res) => {
//         setSubAdmins(res.data.data || res.data);
//         setLoading(false);
//       })
//       .catch(() => {
//         alert("Failed to load sub admins");
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     fetchSubAdmins();
//   }, []);

//   /* ---------------- INPUT HANDLERS ---------------- */
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleServiceChange = (service) => {
//     setFormData((prev) => ({
//       ...prev,
//       services: prev.services.includes(service)
//         ? prev.services.filter((s) => s !== service)
//         : [...prev.services, service],
//     }));
//   };

//   /* ---------------- OPEN FORMS ---------------- */
//   const openCreate = () => {
//     setEditId(null);
//     setFormData({
//       username: "",
//       mobile: "",
//       password: "",
//       services: []
//     });
//     setShowForm(true);
//   };

//   const openEdit = (admin) => {
//     setEditId(admin._id);
//     setFormData({
//       username: admin.username,
//       mobile: admin.mobile,
//       password: "",
//       services: admin.services || []
//     });
//     setShowForm(true);
//   };

//   /* ---------------- CREATE / UPDATE ---------------- */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.username || !formData.mobile) {
//       alert("Username and mobile are required");
//       return;
//     }

//     const url = editId
//       ? `${API_BASE_URL}/admin/subadmin/${editId}`
//       : `${API_BASE_URL}/admin/subadmin`;

//     const method = editId ? axios.put : axios.post;

//     method(url, formData, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     })
//       .then(() => {
//         alert(editId ? "Sub Admin Updated" : "Sub Admin Created");
//         setShowForm(false);
//         fetchSubAdmins();
//       })
//       .catch(() => alert("Operation failed"));
//   };

//   /* ---------------- ACTIVATE / DEACTIVATE ---------------- */
//   const toggleStatus = (id) => {
//     axios
//       .patch(
//         `${API_BASE_URL}/admin/subadmin/${id}/status`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       )
//       .then(fetchSubAdmins)
//       .catch(() => alert("Failed to update status"));
//   };

//   /* ---------------- UI ---------------- */
//   return (
//     <div style={{ padding: 20, background: "#f4f6f9", minHeight: "100vh" }}>
//       <h2>Sub Admin Management</h2>

//       {/* FORM */}
//       {showForm && (
//         <div style={formWrapper}>
//           <h3>{editId ? "Update Sub Admin" : "Create Sub Admin"}</h3>

//           <form onSubmit={handleSubmit}>
//             <input
//               name="username"
//               placeholder="Email"
//               value={formData.username}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <input
//               name="mobile"
//               placeholder="Mobile"
//               value={formData.mobile}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             <input
//               name="password"
//               type="password"
//               placeholder="Password"
//               value={formData.password}
//               onChange={handleChange}
//               style={inputStyle}
//             />

//             {/* SERVICES */}
//             <h4 style={{ marginTop: 10 }}>Service Access</h4>
//             <div style={serviceGrid}>
//               {SERVICES.map((service) => (
//                 <label key={service.value} style={checkboxLabel}>
//                   <input
//                     type="checkbox"
//                     checked={formData.services.includes(service.value)}
//                     onChange={() => handleServiceChange(service.value)}
//                   />
//                   {service.label}
//                 </label>
//               ))}
//             </div>

//             <div style={{ display: "flex", gap: 10, marginTop: 15 }}>
//               <button type="submit" style={primaryBtn}>
//                 Save
//               </button>
//               <button
//                 type="button"
//                 onClick={() => setShowForm(false)}
//                 style={secondaryBtn}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}

//       <button onClick={openCreate} style={{ ...primaryBtn, marginBottom: 10 }}>
//         + Create Sub Admin
//       </button>

//       {/* TABLE */}
//       <table style={tableStyle}>
//         <thead>
//           <tr>
//             <th>Email</th>
//             <th>Mobile</th>
//             <th>Services</th>
//             <th>Status</th>
//             <th style={{ textAlign: "right" }}>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {loading ? (
//             <tr>
//               <td colSpan="5" style={{ textAlign: "center" }}>
//                 Loading...
//               </td>
//             </tr>
//           ) : (
//             subAdmins.map((admin) => (
//               <tr key={admin._id}>
//                 <td>{admin.username}</td>
//                 <td>{admin.mobile}</td>
//                 <td>{admin.services?.join(", ") || "—"}</td>
//                 <td>{admin.isActive ? "Active" : "Inactive"}</td>
//                 <td style={{ textAlign: "right" }}>
//                   <button onClick={() => openEdit(admin)} style={editBtn}>
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => toggleStatus(admin._id)}
//                     style={admin.isActive ? dangerBtn : successBtn}
//                   >
//                     {admin.isActive ? "Deactivate" : "Activate"}
//                   </button>
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// /* ---------------- STYLES ---------------- */
// const formWrapper = {
//   background: "#fff",
//   padding: 20,
//   borderRadius: 8,
//   marginBottom: 20,
//   boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
// };

// const serviceGrid = {
//   display: "grid",
//   gridTemplateColumns: "1fr 1fr",
//   gap: 8,
// };

// const checkboxLabel = {
//   display: "flex",
//   gap: 6,
//   alignItems: "center",
// };

// const inputStyle = {
//   width: "100%",
//   padding: 10,
//   marginBottom: 10,
//   borderRadius: 6,
//   border: "1px solid #ccc",
// };

// const primaryBtn = {
//   background: "#2563eb",
//   color: "#fff",
//   padding: "10px 14px",
//   border: "none",
//   borderRadius: 6,
//   cursor: "pointer",
// };

// const secondaryBtn = {
//   background: "#e5e7eb",
//   padding: "10px 14px",
//   border: "none",
//   borderRadius: 6,
//   cursor: "pointer",
// };

// const editBtn = {
//   background: "#facc15",
//   padding: "6px 10px",
//   border: "none",
//   borderRadius: 5,
//   marginRight: 6,
// };

// const dangerBtn = {
//   background: "#dc2626",
//   color: "#fff",
//   padding: "6px 10px",
//   border: "none",
//   borderRadius: 5,
// };

// const successBtn = {
//   background: "#16a34a",
//   color: "#fff",
//   padding: "6px 10px",
//   border: "none",
//   borderRadius: 5,
// };

// const tableStyle = {
//   width: "100%",
//   background: "#fff",
//   borderCollapse: "collapse",
// };

// export default Settings;









































import React, { useEffect, useState } from "react";
import axios from "axios";

/* SERVICES */
const SERVICES = [
  { label: "Exam Notes", value: "exam_notes" },
  { label: "Student Profile", value: "student_profile" },
  { label: "Choose Career", value: "choose_career" },
  { label: "Home Tutor", value: "home_tutor" },
  { label: "Homework Assistance", value: "homework_assistance" },
  { label: "Subjective Exam", value: "subjective_exam" },
  { label: "Assignment", value: "assignment" },
  { label: "Jobs", value: "jobs" },
  { label: "current Affairs", value: "current_affairs" },
];

const Settings = () => {

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [subAdmins, setSubAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    password: "",
    services: []
  });

  /* FETCH SUB ADMINS */
  

  const fetchSubAdmins = async () => {
    try {

      setLoading(true);

      const res = await axios.get(`${API_BASE_URL}/admin/subadmin`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      console.log(res);

      setSubAdmins(res.data.data || res.data);

    } catch (err) {

      alert(err.response?.data?.message || "Failed to load sub admins");

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubAdmins();
  }, []);

  /* INPUT HANDLER */

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

  };

  const handleServiceChange = (service) => {

    setFormData(prev => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter(s => s !== service)
        : [...prev.services, service]
    }));

  };

  /* OPEN CREATE */

  const openCreate = () => {

    setEditId(null);

    setFormData({
      username: "",
      mobile: "",
      password: "",
      services: []
    });

    setShowForm(true);

  };

  /* OPEN EDIT */

  const openEdit = (admin) => {

    setEditId(admin._id);

    setFormData({
      username: admin.username,
      mobile: admin.mobile,
      password: "",
      services: admin.services || []
    });

    setShowForm(true);

  };

  /* SUBMIT */

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!formData.username || !formData.mobile) {
      return alert("Username and mobile are required");
    }

    if (!/^\d{10}$/.test(formData.mobile)) {
      return alert("Mobile must be 10 digits");
    }

    try {

      const payload = { ...formData };

      if (editId && !payload.password) {
        delete payload.password;
      }

      const url = editId
        ? `${API_BASE_URL}/admin/subadmin/${editId}`
        : `${API_BASE_URL}/admin/subadmin`;

      const method = editId ? axios.put : axios.post;

      await method(url, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      alert(editId ? "Sub Admin Updated" : "Sub Admin Created");

      setShowForm(false);

      fetchSubAdmins();

    } catch (err) {

      alert(err.response?.data?.message || "Operation failed");

    }
  };

  /* TOGGLE STATUS */

  const toggleStatus = async (id) => {

    try {

      await axios.patch(
        `${API_BASE_URL}/admin/subadmin/${id}/status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

      fetchSubAdmins();

    } catch (err) {

      alert(err.response?.data?.message || "Status update failed");

    }

  };

  /* HELPER */

  const getServiceLabels = (services = []) => {

    return services
      .map(s => SERVICES.find(x => x.value === s)?.label)
      .filter(Boolean)
      .join(", ");

  };

  /* UI */

  return (
    <div style={{ padding: 20, background: "#f4f6f9", minHeight: "100vh" }}>

      <h2>Sub Admin Management</h2>

      {showForm && (
        <div style={formWrapper}>

          <h3>{editId ? "Update Sub Admin" : "Create Sub Admin"}</h3>

          <form onSubmit={handleSubmit}>

            <input
              name="username"
              placeholder="Email"
              value={formData.username}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              name="mobile"
              placeholder="Mobile"
              value={formData.mobile}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              name="password"
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              style={inputStyle}
            />

            <h4>Service Access</h4>

            <div style={serviceGrid}>

              {SERVICES.map(service => (

                <label key={service.value} style={checkboxLabel}>

                  <input
                    type="checkbox"
                    checked={formData.services.includes(service.value)}
                    onChange={() => handleServiceChange(service.value)}
                  />

                  {service.label}

                </label>

              ))}

            </div>

            <div style={{ display: "flex", gap: 10, marginTop: 15 }}>

              <button type="submit" style={primaryBtn}>
                Save
              </button>

              <button
                type="button"
                onClick={() => setShowForm(false)}
                style={secondaryBtn}
              >
                Cancel
              </button>

            </div>

          </form>

        </div>
      )}

      <button onClick={openCreate} style={{ ...primaryBtn, marginBottom: 10 }}>
        + Create Sub Admin
      </button>

      <table style={tableStyle}>

        <thead>

          <tr>
            <th>Email</th>
            <th>Mobile</th>
            <th>Password</th>
            <th>Services</th>
            <th>Status</th>
            <th style={{ textAlign: "right" }}>Actions</th>
          </tr>

        </thead>

        <tbody>

          {loading ? (

            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                Loading...
              </td>
            </tr>

          ) : (

            subAdmins.map(admin => (

              <tr key={admin._id}>

                <td>{admin.username}</td>

                <td>{admin.mobile}</td>
                <td>{admin.password}</td>

                <td>{getServiceLabels(admin.services)}</td>

                <td>{admin.isActive ? "Active" : "Inactive"}</td>

                <td style={{ textAlign: "right" }}>

                  <button
                    onClick={() => openEdit(admin)}
                    style={editBtn}
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => toggleStatus(admin._id)}
                    style={admin.isActive ? dangerBtn : successBtn}
                  >
                    {admin.isActive ? "Deactivate" : "Activate"}
                  </button>

                </td>

              </tr>

            ))

          )}

        </tbody>

      </table>

    </div>
  );
};

/* STYLES */

const formWrapper = {
  background: "#fff",
  padding: 20,
  borderRadius: 8,
  marginBottom: 20,
  boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
};

const serviceGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 8
};

const checkboxLabel = {
  display: "flex",
  gap: 6,
  alignItems: "center"
};

const inputStyle = {
  width: "100%",
  padding: 10,
  marginBottom: 10,
  borderRadius: 6,
  border: "1px solid #ccc"
};

const primaryBtn = {
  background: "#2563eb",
  color: "#fff",
  padding: "10px 14px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer"
};

const secondaryBtn = {
  background: "#e5e7eb",
  padding: "10px 14px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer"
};

const editBtn = {
  background: "#facc15",
  padding: "6px 10px",
  border: "none",
  borderRadius: 5,
  marginRight: 6
};

const dangerBtn = {
  background: "#dc2626",
  color: "#fff",
  padding: "6px 10px",
  border: "none",
  borderRadius: 5
};

const successBtn = {
  background: "#16a34a",
  color: "#fff",
  padding: "6px 10px",
  border: "none",
  borderRadius: 5
};

const tableStyle = {
  width: "100%",
  background: "#fff",
  borderCollapse: "collapse"
};

export default Settings;